// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


//////////////////
// WEBPACK FOOTER
// ../~/.2.4.1@core-js/library/modules/_enum-bug-keys.js
// module id = 16
// module chunks = 0